<template>
    <v-card
        v-if="!loading"
        flat
    >
        <v-card-text>
            <v-layout wrap>
                <v-flex
                    xs12
                >
                    <template
                        v-if="lead.comments.length"
                    >
                        <v-timeline
                            dense
                            clipped
                            class="calendar-comments"
                        >
                            <v-timeline-item
                                class="mb-4"
                                color="secondary"
                                small
                                v-for="(comment, index) in lead.comments"
                                :key="index"
                            >
                                <v-row
                                    justify="space-between"
                                >
                                    <v-col cols="12">
                                        {{ comment.comment }} <br>
                                        <h5>{{ comment.user_name }} -  {{ comment.dateCreated.slice(0, -3) }}</h5>
                                    </v-col>
                                </v-row>
                            </v-timeline-item>
                        </v-timeline>
                    </template>
                    <template
                        v-else
                    >
                        <h3
                            class="text-center mt-3"
                        >
                            No available comments
                        </h3>
                    </template>
                </v-flex>
            </v-layout>
        </v-card-text>
    </v-card>
</template>
<script>
    export default {
        data() {
            return {
                loading: true,
                lead: {},
            }
        },
        props: ['itemInfo'],
        name: 'Lead-Comments',
        mounted() {
            this.lead = this.itemInfo;

            setTimeout(() => {
                this.loading = false;
            }, 100);
        },
    }
</script>
